import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import CellcomAppBlockData from "../../../Models/Content/CellcomAppBlockData";
import OpenCellcomApp from './OpenCellcomApp';
export default class CellcomAppBlock extends EpiComponent<CellcomAppBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return (
      <div>
        <OpenCellcomApp context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}

